import URLs from "../config";

export const auth = {
  LOG_IN: URLs.API + "/api/login",
};
export const profile = {
  LIST: URLs.API + "/api/profiles",
  DELETE: URLs.API + "/api/profiles/",
  ADD: URLs.API + "/api/profiles",
  PARTICULAR: URLs.API + "/api/profiles/",
  ADMIN_PARTICULAR: URLs.API + "/api/profiles/",
  UPDATE: URLs.API + "/api/profiles/",
  UPLOAD: URLs.API + "/api/upload",
  PUSH_NOTIFICATION: URLs.API + "/api/push-notification",
};

export const district = {
  DISTRICT: URLs.API + "/api/districts",
};
